import React from 'react';
import { Link } from 'react-router-dom';
import { getCurrencySymbol } from 'utils/currency';
import { formatMoney } from 'utils/numbers';

const PaidSubscriptionBlock = ({ type, sub, currentPlan, t }) => {
	const getDataForType = () => {
		switch (type) {
			case "vat":
				return {
					title: 'VAT subscription',
					sum: currentPlan.subscriptions?.sum,
					nextBillDate: currentPlan.your_next_billing_date,
					planName: sub?.tariff_plan?.name || sub?.name || 'Standard'
				};
			case "sales tax":
				return {
					title: 'Sales tax subscription',
					sum: currentPlan?.subscriptions_sales_tax?.sum,
					nextBillDate: currentPlan.your_next_billing_date_sales_tax,
					planName: sub?.tariff_plan?.name || 'Standard'
				};
			case "epr":
				return {
					title: 'EPR subscription',
					sum: currentPlan?.subscriptions_epr?.sum,
					nextBillDate: currentPlan.your_next_billing_date_epr,
					planName: sub?.tariff_plan?.name || 'Standard'
				};
			case "omp":
				return {
					title: 'OMP subscription',
					sum: currentPlan?.subscriptions_omp?.sum,
					nextBillDate: currentPlan.your_next_billing_date_omp,
					planName: sub?.tariff_plan?.name || 'Standard'
				};
			case "invoice":
				return {
					title: 'Invoice subscription',
					sum: currentPlan?.subscriptions_invoice?.sum ?? currentPlan?.subscriptions_invoice?.subscriptions?.sum,
					nextBillDate: currentPlan?.subscriptions_invoice?.your_next_billing_date ?? currentPlan?.subscriptions_invoice?.your_next_billing_date_invoice,
					planName: sub?.tariff_plan?.name || sub?.name || 'Standard'
				};
			case "authorize":
				return {
					title: 'Authorize subscription',
					sum: sub?.sum,
					nextBillDate: sub?.your_next_billing_date,
					planName: sub?.tariff_plan?.name || sub?.name || 'Standard'
				};
			default:
				return {
					title: 'Subscription',
					sum: 0,
					nextBillDate: null,
					planName: 'Standard'
				};
		}
	};

	const { title, sum, nextBillDate, planName } = getDataForType();

	const formatDate = (dateString) => {
		if (!dateString) return '';
		const date = new Date(dateString);
		return date.toLocaleDateString('en-GB', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		});
	};

	return (
		<div className="paid-subscription-block">
			<div className="subscription-header">
				<div className="subscription-title">{title}</div>
				<div className="billing-info">
					Next billing date: {formatDate(nextBillDate)}
				</div>
			</div>

			<div className="subscription-plan">
				<div className="plan-indicator"></div>
				<span className="plan-name">{planName}</span>
			</div>
		</div>
	);
};

export default PaidSubscriptionBlock;
